import React, { FC } from 'react';
import Address from 'src/common/components/Address';
import { Locations } from 'src/types/boat/Locations';
import getStaticMapUrl from 'src/common/utils/getStaticMapUrl';
import styles from './LocationOverview.module.scss';

export type LocationOverviewProps = {
  locations: Locations;
};

const MAP_WIDTH = 389;
const MAP_HEIGHT = 205;

const LocationOverview: FC<LocationOverviewProps> = ({
  locations,
}) => {
  if (!locations.length) return null;
  const location = locations[0];

  const {
    street_address: streetAddress,
    street_city: streetCity,
    street_state: streetState,
    street_zip: streetZip,
    street_country: streetCountry,
    street_latitude: streetLatitude,
    street_longitude: streetLongitude,
    departure_city: departureCity,
    departure_state: departureState,
    departure_zip: departureZip,
    departure_country: departureCountry,
    departure_latitude: departureLatitude,
    departure_longitude: departureLongitude,
    arrival_instructions: arrivalInstructions,
  } = location;

  const mapUrl = getStaticMapUrl({
    departGeo: `${departureLongitude},${departureLatitude}`,
    streetGeo: `${streetLongitude},${streetLatitude}`,
    width: MAP_WIDTH,
    height: MAP_HEIGHT,
  });

  const sameAsStreetAddress = streetLatitude === departureLatitude
  && streetLongitude === departureLongitude;
  const departureAddress = sameAsStreetAddress ? 'Same as Street Address' : `${departureLatitude}, ${departureLongitude}`;

  return (
    <div className={styles.root}>
      {mapUrl && (
        <img
          alt="The boat's approximate location on a map"
          src={mapUrl}
          className={styles.image}
          width={MAP_WIDTH}
          height={MAP_HEIGHT}
        />
      )}
      <div className={styles.addresses}>
        <Address
          title="Street Address For Arrival"
          address={streetAddress || `${streetLatitude}, ${streetLongitude}`}
          city={streetCity}
          state={streetState}
          zip={streetZip}
          country={streetCountry}
          latitude={streetLatitude}
          longitude={streetLongitude}
          withMapLink
        />
        <Address
          title="Departure Location"
          iconColor="green"
          address={departureAddress}
          city={departureCity}
          state={departureState}
          zip={departureZip}
          country={departureCountry}
          latitude={departureLatitude}
          longitude={departureLongitude}
          withMapLink
          sameAddress={sameAsStreetAddress}
        />
      </div>
      {arrivalInstructions && (
        <div>
          <p className={styles.arrivalTitle}>
            Directions Upon Arrival
          </p>
          <p className={styles.arrivalInstructions}>
            {arrivalInstructions}
          </p>
        </div>
      )}
    </div>
  );
};

export default LocationOverview;
